import React, { Component } from "react";
import { SIDE_NAV_ITEMS, API_URLS } from "../../api-constant";
import NewNavBar from "../NavBar/Navbar";
import Sidebar from "../Sidebar/sidebar";
import ResponsiveSidebar from "../Sidebar/Responsive/SideBar";
import CompletedAssessment from "./CompletedAssessment";
import ResponsiveCompletedAssessment from "./Responsive/CompletedAssessment";
import { withRouter } from "react-router";
import axios from "axios";

import addAccessTokenToUrl from "../../Utils/Axios/addTokenToUrl";
import Navbar from "../../../_components/common/Navbar";
const initialEmailFormObject = {
  inputType: "email",
  name: "name",
  inputId: "email",
  value: "",
};
const initialRelationFormObject = {
  inputType: "select",
  name: "relationship",
  inputId: "relationship",
  value: "",
};
const calcWidth = window.innerWidth;
export class Rendercompletedassessmentscreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedSideNav: SIDE_NAV_ITEMS[0].id,
      sidebarOpen: false,
      assessmentModal: false,
      inputFields: [
        { ...initialEmailFormObject },
        { ...initialRelationFormObject },
        { ...initialEmailFormObject },
        { ...initialRelationFormObject },
        { ...initialEmailFormObject },
        { ...initialRelationFormObject },
      ],
      isChecked: false,
      isDisabled: true,
      reviewMode: false,
      enableNotification: false,
      userCompletedAssessmentDetails: null,
      dropDownOptions: [],
      emailValue: [],
      relationShipValue: [],
      orgId: "",
      sellerId: "",
      relationShipName: "",
      isPopOverOpenRelationshipName: false,
      overlayIsVisible: false,
      getMinBatchRespondents: "",
      isEmailValid: true
    };
  }

  accessorGroupApi = () => {
    const sellerId = this.state.sellerId;
    const orgId = this.state.orgId;

    axios
      .get(
        addAccessTokenToUrl(
          API_URLS.Respondent_Relation_Accessor_Dropdown({ sellerId, orgId })
        )
      )
      .then((response) => {
        this.setState({
          dropDownOptions: response.data.organisation_assessor_group_list,
        });
      })
      .catch((error) => {
        console.error(error);
      });
  };
  componentDidMount() {
    const user = this.props.match.params.id;
    const participant = this.props.match.params.participant__id;
    const instrumentMultiRater = this.props.match.params.isMultiRater;
    const minBatchRespondents = this.props.match.params.min_batch_respondents;

    axios
      .get(addAccessTokenToUrl("/assessments/user/active/assessments/"))
      .then((response) => {
        const userCompletedAssessmentDetails = response.data.user_assessments.find(
          (userId) => {
            return userId.id == user;
          }
        );
        this.setState(
          {
            userCompletedAssessmentDetails,
            orgId: userCompletedAssessmentDetails.organisation,
            sellerId: userCompletedAssessmentDetails.seller,
            getMinBatchRespondents: minBatchRespondents,
          },
          () => {
            this.accessorGroupApi();
          }
        );
      })
      .catch((error) => {
        console.error(error);
      });
  }
  handleAssessmentSubmit = () => {
    this.setState({
      assessmentModal: true,
    });
  };

  handleModalClose = () => {
    this.setState({
      assessmentModal: false,
      isDisabled: true,
    });
  };

  handleInputFields = () => {
    this.setState({
      inputFields: [
        ...this.state.inputFields,
        initialEmailFormObject,
        initialRelationFormObject,
      ],
      isChecked: !this.state.isChecked,
    });

    setTimeout(() => {
      this.setState({
        isChecked: false,
      });
    }, 200);
  };

  handleMultipleEmail = (inputValue, inputFieldIndex) => {

    const isValid = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(inputValue)


    if (!isValid) {
      this.setState({
        isEmailValid: true
      })
    }
    if (inputFieldIndex === 4) {
      this.setState({
        isDisabled: false,
      });
    }
    const inputId = document.getElementById(`email-${inputFieldIndex}`);

    const showErrors = document.getElementById(`error-${inputFieldIndex}`);
    if (inputId && inputId.value == "") {
      showErrors.innerHTML = "*Email cannot be empty";
      showErrors.style.color = 'red'
      showErrors.style.fontSize = '12px'
      return;
    }
    if (isValid === false) {
      showErrors.innerHTML = "*please enter a valid email address";
      showErrors.style.color = 'red'
      showErrors.style.fontSize = '12px'
      return;
    }
    if (isValid === true) {
      showErrors.innerHTML = "";
      return;
    }

  };

  handleMultipleSelect = (relationName, selectValueIndex) => {
    const getLocalStorageItem = localStorage.getItem(
      `${relationName} Relationship`
    );
    if (!getLocalStorageItem) {
      this.setState({
        isPopOverOpenRelationshipName: relationName,
        overlayIsVisible: true,
        relationShipName: relationName,
      });
    }
    if (selectValueIndex === 5) {
      this.setState({
        isDisabled: false,
      });
    }

  };
  handleClosePopOver = () => {
    this.setState({
      isPopOverOpenRelationshipName: false,
      overlayIsVisible: false,
    });
  };


  handleInviteModalSubmit = () => {
    const user = this.props.match.params.id;
    const participant = this.props.match.params.participant__id;
    const instrumentMultiRater = this.props.match.params.isMultiRater;
    const emailState = [];
    const relationState = [];
    let breakLoop = false;
    this.state.inputFields.forEach((i, index) => {
      if (breakLoop) {
        return;
      }
      if (i.inputType == "email") {
        const inputId = document.getElementById(`email-${index}`);

        const showErrors = document.getElementById(`error-${index}`);
        const mailformat = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (inputId.value == "") {
          showErrors.innerHTML = "Email cannot be empty";
          breakLoop = true;
          return;
        }
        if (!inputId.value.match(mailformat)) {
          showErrors.innerHTML = "Enter a valid email address";
          breakLoop = true;
          return;
        }
        emailState.push(inputId.value);
      } else {
        const selectId = document.getElementById(`select-${index}`);
        const findId = this.state.dropDownOptions.find((selectedDropdownId) => {
          return (
            selectedDropdownId.assessor_group__assessor_name == selectId.value
          );
        });
        relationState.push(findId.id);
      }
    });
    emailState.forEach((elem, index) => {
      /* call invite respondants api here */
      axios
        .post(
          addAccessTokenToUrl("/assessments/user/respondent/allot/assessment/"),
          {
            organisation_user_assessement_id: user,
            accessor_group_id: relationState[index],
            email_id: [elem],
          }
        )
        .then((response) => {
          this.props.history.push(
            `/new/app/invitations/${user}/${participant}/${instrumentMultiRater}`
          );
          this.setState({
            isDisabled: true,
            inputFields: [initialEmailFormObject, initialRelationFormObject],
          });
        })
        .catch((error) => {
          console.error(error);
        });
    });
  };

  handleModalFormSubmit = (e) => {
    e.preventDefault();
  };

  handleNotification = () => {
    this.setState({
      enableNotification: !this.state.enableNotification,
    });
  };

  onSetSidebarOpen = (open) => {
    this.setState({
      sidebarOpen: open,
    });
  };

  handleCloseNotification = () => {
    this.setState({
      enableNotification: false
    })
  }

  render() {
    const userType = localStorage.getItem("usertype");
    return (
      <div>
        {userType.includes("organisation_admin") || userType.includes("seller_admin") ? (
          <Navbar />
        ) : (
          <NewNavBar
            enableNotification={this.state.enableNotification}
            handleNotification={this.handleNotification}
            handleCloseNotification={this.handleCloseNotification}
          />
        )}
        {!userType.includes("organisation_admin") && !userType.includes("seller_admin") ? (
          <Sidebar
            items={SIDE_NAV_ITEMS}
            selectedSideNav={this.state.selectedSideNav}
          />
        ) : null}
        {userType.includes("organisation_admin") || userType.includes("seller_admin") ? null : (
          <ResponsiveSidebar
            items={SIDE_NAV_ITEMS}
            selectedSideNav={this.state.selectedSideNav}
            sidebarOpen={this.state.sidebarOpen}
            onSetSidebarOpen={this.onSetSidebarOpen}
          />
        )}

        {calcWidth <= 767 ? (
          <ResponsiveCompletedAssessment
            handleAssessmentSubmit={this.handleAssessmentSubmit}
            assessmentModal={this.state.assessmentModal}
            handleModalClose={this.handleModalClose}
            inputFields={this.state.inputFields}
            handleInputFields={this.handleInputFields}
            dropDownOptions={this.state.dropDownOptions}
            handleMultipleEmail={this.handleMultipleEmail}
            isEmailValid={this.state.isEmailValid}
            isChecked={this.state.isChecked}
            isDisabled={this.state.isDisabled}
            handleModalFormSubmit={this.handleModalFormSubmit}
            reviewMode={this.state.reviewMode}
            isPopOverOpenRelationshipId={this.state.isPopOverOpenRelationshipId}
            getMinBatchRespondents={this.state.getMinBatchRespondents}
            handleInviteModalSubmit={this.handleInviteModalSubmit}
          />
        ) : (
          <CompletedAssessment
            handleAssessmentSubmit={this.handleAssessmentSubmit}
            assessmentModal={this.state.assessmentModal}
            handleModalClose={this.handleModalClose}
            inputFields={this.state.inputFields}
            handleInputFields={this.handleInputFields}
            dropDownOptions={this.state.dropDownOptions}
            handleMultipleEmail={this.handleMultipleEmail}
            isEmailValid={this.state.isEmailValid}
            handleMultipleSelect={this.handleMultipleSelect}
            isChecked={this.state.isChecked}
            isDisabled={this.state.isDisabled}
            handleModalFormSubmit={this.handleModalFormSubmit}
            reviewMode={this.state.reviewMode}
            userCompletedAssessmentDetails={
              this.state.userCompletedAssessmentDetails
            }

            handleInviteModalSubmit={this.handleInviteModalSubmit}
            isPopOverOpenRelationshipName={
              this.state.isPopOverOpenRelationshipName
            }
            overlayIsVisible={this.state.overlayIsVisible}
            relationShipName={this.state.relationShipName}
            handleClosePopOver={this.handleClosePopOver}
            getMinBatchRespondents={this.state.getMinBatchRespondents}
          />
        )}
      </div>
    );
  }
}

export default withRouter(Rendercompletedassessmentscreen);



// WEBPACK FOOTER //
// ./src/new/Components/CompletedAssessment/index.jsx